import { render, staticRenderFns } from "./PageSkeletonThee.vue?vue&type=template&id=880537aa&scoped=true"
import script from "./PageSkeletonThee.vue?vue&type=script&lang=js"
export * from "./PageSkeletonThee.vue?vue&type=script&lang=js"
import style0 from "./PageSkeletonThee.vue?vue&type=style&index=0&id=880537aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880537aa",
  null
  
)

export default component.exports